// The files the loading screen waits for, with the byte size of each one on
// disk. Nginx gzips the car exports without sending a Content-Length, so their
// live download cannot be measured from the browser; each file's share of the
// bar comes from this table instead, which is also the order the parallel
// downloads finish in. tests/unit/games/gt-racing/car-model-payload.test.mjs
// keeps every number honest against the files themselves.
export const LOADING_ASSETS = Object.freeze([
  { id: 'daylight', path: 'assets/circuit-daylight-v4.hdr', bytes: 920910 },
  { id: 'ember', path: 'assets/licensed/ember-review.glb', bytes: 3371736 },
  { id: 'eagle', path: 'assets/licensed/eagle-review.glb', bytes: 427316 },
  { id: 'thunder', path: 'assets/licensed/thunder-review.glb', bytes: 709776 },
  { id: 'venom', path: 'assets/licensed/venom-review.glb', bytes: 1590460 },
  { id: 'titan', path: 'assets/licensed/titan-review.glb', bytes: 509124 }
]);
